import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import './style.scss';
import {saveBreadcrumb} from "../../../../actions";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import { div0 } from '@formulajs/formulajs/lib/utils/error';

@connect((state)=>{
    return {}
},(dispatch)=>{
    return {
        ...bindActionCreators({ saveBreadcrumb },dispatch)
    }
})

class Breadcrumb extends Component {
    constructor(props) {
        super(props);
        this.state = {
            iterate: 0,
            redirectToGeneralFaqs: false,
        }
    }

    componentDidMount = () => {
        let {location}=this.props;
        if((location.pathname === '/investor-desk/faqs/general') || (location.pathname === '/investor-desk/faqs/online')) {
            this.setState({
                redirectToGeneralFaqs: true,
            });
        }
    }

    createBreadcrumb = (path, index, length) => {
        // for information template dont show information breadcrumb
        if(path && path.name=="information"){
            return
        }
        //disable link for nav n dividend page
        return (
            <li key={index}>
                {index === 0 ?
                    <a style={{position: 'relative'}} href='/' target='_self'>{path.name}</a> :
                    (this.state.redirectToGeneralFaqs && (length-1==index || length-2==index)) ? <a style={{position: 'relative'}} href={path.url} className='disabled'>
                    {path.name}
                </a> : 
                <Link style={{position: 'relative'}} to={path.url} className={(path.url=="/nav-and-dividend" || path.url=="/information") ||
                    (length-1==index && path.url!='/') ? 'disabled': ''}>
                    {path.name}
                </Link> }
            </li>
        )
    };
    saveBreadcrumbList = (data) => {
        data[0].url = __CLIENT__ && window.location.origin ? window.location.origin : "https://www.hdfcfund.com";
        let { saveBreadcrumb } = this.props;
        this.setState({
            iterate: 1,
        })
        saveBreadcrumb && saveBreadcrumb(data);
    }
    render() {
        const {location: {pathname}, dashInclude, title} = this.props;
        let paths = pathname && pathname.split('/');
        const current = pathname && pathname.split("/")[1];

        let breadcrumbList = [],
            breadcrumb = {},
            pageName=[],
            pathURL = '',
        url;
        paths.map((path,index) => {
            if (path == '') {
                breadcrumb = {name: 'Home', url: '/'}
            } else if (path == 'global-search' || path == 'en' || path == 'hi' || path.match(/(^\d)+/)) {
                return;
                /**/
            } else if (dashInclude === true) {
                pathURL += '/' + path;
                let customPath1 = path.slice(0,6);
                if(customPath1.includes("hdfc-")){
                    customPath1 = customPath1.replace(/-/g, ' ')
                }
                let customPath2 = path.slice(6);
                let customPath = customPath1+(customPath2.replace(/-/g, ' '));
                breadcrumb = {name: customPath, url: pathURL}
            } else if(path.toLowerCase().includes('hdfc')) {
                pathURL += '/' + path;
                breadcrumb = {name: path.replace(path.substring(0,4),path.substring(0,4).toUpperCase()).replace(/-/g, ' '), url: pathURL}
            }
            
            else {
                pathURL += '/' + path;
                breadcrumb = {name: path.replace(/-/g, ' '), url: pathURL}
            }
            // if((paths.length - 2) == index ){
            //     url = breadcrumb.url;
            // }
            breadcrumbList.push(breadcrumb);
            if(breadcrumbList.length > 1 && breadcrumbList[breadcrumbList.length - 1].name === 'Home') {
                breadcrumbList = breadcrumbList.slice(0,breadcrumbList.length-1);
            }
            pageName = breadcrumbList[breadcrumbList.length - 1].name.split(" ");

        });
        if(paths.includes("learn") && (paths.includes("investments") || paths.includes("mutual-funds") || paths.includes("financial")
        || paths.includes("being-career-smart-kids") || paths.includes("raising-money-smart-kids") || paths.includes("being-money-smart-parent") || paths.includes("being-money-smart-for-child-education"))){
          breadcrumbList.pop();
        }

        return (
            <ul className={this.props.fullWidth?'breadcrumb-section clearfix width-100':'breadcrumb-section clearfix'}>
                {this.state.iterate < 1 && this.saveBreadcrumbList(breadcrumbList)}
                {breadcrumbList && breadcrumbList.length && breadcrumbList.map((path, index)=>{
                    const isLastBreadcrumb = index === breadcrumbList.length - 1;
                    if (isLastBreadcrumb && (current === 'statutory-disclosure' || current === 'distributor-corner' || current === 'investor-services')) {
                        return <li key={index} className="hidden"><a className="disabled">{path.name}</a></li>
                    }
                    else{
                        return this.createBreadcrumb(path, index,breadcrumbList.length )
                    }
                })}
                
                {current === 'statutory-disclosure' || current === 'distributor-corner' || current === 'investor-services' ? 
                <>
                {this.props.className && <h1 className={title && title.length > 61 ? 'page-name pagenametitle' : 'page-name'}>
                    {title && title.split(' ').slice(0, -1).join(' ')} <span className='last-word'> {title && title.split(' ').slice(-1)}</span>
                    </h1> }
                </> :
                <>
                {current === 'careers' ?
                    <>
                    {this.props.className &&
                    <div className='page-name'>{pageName.map(item => <li><h1>{item.toLowerCase().includes('hdfc') ? item.replace(item.substring(0,4),item.substring(0,4).toUpperCase()) : item.charAt(0).toUpperCase() + item.slice(1)}</h1></li>)}</div>}
                    </>
                    :
                    <>
                    {this.props.className && 
                    <h1 className='page-name'>
                        {pageName.map(item => 
                        <li>{item.toLowerCase().includes('hdfc') ? item.replace(item.substring(0,4),item.substring(0,4).toUpperCase()) : item.charAt(0).toUpperCase() + item.slice(1)}</li>)}
                    </h1>}
                    </>
                }
                </>}
                
            </ul>
        );
    }
}

export default Breadcrumb;
